exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n\n\n@media (max-width: 375px) {\n  .card__CardCounters-module___2S2JG {\n    min-width: 260px;\n  }\n}\n\n@media (max-width: 425px) {\n    .card__CardCounters-module___2S2JG .row__CardCounters-module___2yitY {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n.card__CardCounters-module___2S2JG .row__CardCounters-module___2yitY .cell1__CardCounters-module___fC_EB {\n    border-bottom: none;\n    font-weight: 400;\n}\n.card__CardCounters-module___2S2JG .row__CardCounters-module___2yitY .cell2__CardCounters-module___26Wmp {\n    width: 100%;\n}\n}\n", ""]);

// Exports
exports.locals = {
	"card": "card__CardCounters-module___2S2JG",
	"row": "row__CardCounters-module___2yitY",
	"cell1": "cell1__CardCounters-module___fC_EB",
	"cell2": "cell2__CardCounters-module___26Wmp"
};